import { api } from '@/lib/api-client';
import type { PublicUser, Role } from '@/features/auth/types';

export async function listUsersApi(page = 1, pageSize = 50, search?: string) {
  const trimmed = search?.trim();
  const { data } = await api.get<{ items: PublicUser[]; total: number; page: number; pageSize: number }>(
    '/users',
    { params: { page, pageSize, ...(trimmed ? { search: trimmed } : {}) } },
  );
  return data;
}

export interface UpdateUserInput {
  displayName?: string | null;
  role?: Role;
  isActive?: boolean;
}

export async function updateUserApi(id: string, input: UpdateUserInput): Promise<PublicUser> {
  const { data } = await api.patch<{ user: PublicUser }>(`/users/${id}`, input);
  return data.user;
}

export async function deleteUserApi(id: string): Promise<void> {
  await api.delete(`/users/${id}`);
}
